import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { useMe } from "@/context/MeContext";

export const InterestPanel = ({ compact = false }) => {
  const api = useApi();
  const { me } = useMe();
  const [saved, setSaved] = useState(null);
  const [busy, setBusy] = useState(false);
  const country = me.profile?.country;
  useEffect(() => { api.get("/interest/me").then((r) => setSaved(r.data.saved ? r.data.country : false)).catch(() => setSaved(false)); }, [api]);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post("/interest", {}); setSaved(data.country); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className={compact ? "" : "ahu-card p-6 sm:p-8 fade-in"} data-testid="interest-panel">
      <p className="font-display text-xl text-charcoal">Membership is open in New Zealand for now</p>
      <p className="mt-2 text-ink leading-relaxed">We're working on opening AHU membership in more countries. Your free Action Plan is yours to keep, download and return to.</p>
      {saved ? (
        <p className="mt-5 text-[15px] text-charcoal fade-in" data-testid="interest-saved">Thank you. We'll email you when membership opens in {saved}.</p>
      ) : saved === false && (
        <>
          <p className="mt-5 font-medium text-charcoal">Let me know when membership is available where I am</p>
          {!country && <p className="mt-1 text-sm text-ink-soft">Add your country in Settings, Profile first.</p>}
          <button className="btn-gold mt-4 w-full sm:w-auto sm:min-w-[220px]" disabled={busy || !country} onClick={save} data-testid="save-interest-btn">
            {busy ? "Saving" : "Save my interest"}
          </button>
        </>
      )}
    </div>
  );
};
